import { Placeholder, Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

export default function PlaceholderInput({ required, label, hideLabel, flex, minWidth, maxWidth, multiline, className, noMargin, rows, children }) {
    const { custom: { noAsterisk } } = useFormContext();
    
    return (
        <div className={`form-group flex flex-col w-full ${className}`} style={{ flex, minWidth: minWidth + "rem", maxWidth: maxWidth + "rem" }}>
            {!hideLabel && <Form.Label className="text-nowrap text-sm font-medium text-neutral-600 mb-2">{label}{required && !noAsterisk && "*"}</Form.Label>}
            <Placeholder animation="glow">
                <Placeholder className="w-full rounded">
                    <Form.Control size="lg" className="invisible" {...(multiline ? { as: "textarea", rows } : {})} />
                </Placeholder>
            </Placeholder>
            {children}
        </div>
    );
}